




























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Card extends Vue {
  @Prop({ default: false })
  private collapsable!: boolean;

  @Prop({ default: true })
  private open!: boolean;

  @Prop({ default: "fade" })
  private animation!: string;

  @Prop({ default: "" })
  private headerClasses!: string;

  @Prop({ default: "" })
  private title!: string;

  @Prop({ default: "" })
  private icon!: string;

  @Prop({ default: false })
  private isPaddingless!: boolean;

  private isOpen: boolean = this.collapsable ? this.open : true;

  private get hasFooter() {
    return !!this.$slots.footer;
  }

  public toggle() {
    if (!this.collapsable) {
      return;
    }
    this.isOpen = !this.isOpen;
    this.$emit(this.isOpen ? "open" : "close");
  }
}
